module.exports = __webpack_public_path__ + "img/spinner-multicolor.fbfc5f62.svg";